import { Suspense, useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import {
    Bounds,
    Center,
    ContactShadows,
    Sparkles,
    useGLTF,
} from "@react-three/drei";
import * as THREE from "three";

function Model() {
    const { scene } = useGLTF("/models/logo-3d.glb");
    const group = useRef(null);
    const target = useRef(0.6);
    const current = useRef(0.6);

    useFrame((_, delta) => {
        target.current += delta * 0.25;
        current.current = THREE.MathUtils.damp(
            current.current,
            target.current,
            2.5,
            delta,
        );
        if (group.current) group.current.rotation.y = current.current;
    });

    return (
        <group
            ref={group}
            onClick={(e) => {
                e.stopPropagation();
                target.current += Math.PI * 2;
            }}
        >
            <Center>
                <primitive object={scene} />
            </Center>
        </group>
    );
}

export default function Mark3D() {
    return (
        <Canvas
            dpr={[1, 1.75]}
            camera={{ position: [0, 0.3, 4], fov: 38 }}
            gl={{ antialias: true, alpha: true }}
            style={{ touchAction: "pan-y" }}
            data-testid="mark-3d-canvas"
            aria-label="Interactive 3D ate.teen monogram — click to rotate"
        >
            <ambientLight intensity={0.6} />
            <directionalLight position={[4, 6, 4]} intensity={1.6} />
            <directionalLight position={[-4, 3, -4]} intensity={0.5} color="#C8A96A" />
            <Suspense fallback={null}>
                <Bounds fit clip observe margin={1.25}>
                    <Model />
                </Bounds>
                <ContactShadows
                    position={[0, -1.15, 0]}
                    opacity={0.45}
                    scale={8}
                    blur={2.2}
                    far={4}
                />
                <Sparkles
                    count={40}
                    scale={[5, 3, 5]}
                    size={1.5}
                    speed={0.12}
                    opacity={0.45}
                    color="#C8A96A"
                />
            </Suspense>
        </Canvas>
    );
}

useGLTF.preload("/models/logo-3d.glb");
